import { Box, modeColor } from '@talos/kyoko';
import styled from 'styled-components';

export const ContentWrapper = styled(Box)`
  box-shadow: ${({ theme }) => `24px 0px 40px ${modeColor(theme, theme.colors.black.mute, theme.colors.black.dim)}`};
`;
ContentWrapper.defaultProps = { display: 'flex', flexDirection: 'column', p: 'spacing8', flex: '1' };
